import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../../app.config';
import { catchErrorLogRet } from '../../../common/rest.operators';

import { BlDocument } from './model/bl-document.model';
import { BlFocus } from './model/bl-focus.model';
import { BlListDocumentParams } from './model/bl-list-document-params.model';

@Injectable()
export class BehaviourLibraryService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    listDocumentFocuses(published: boolean | null): Observable<BlFocus[]> {
        let params = new HttpParams();
        if (published != null) {
            params = params.set('published', String(published));
        }
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/behaviour-library/document-focuses`,
                { params },
            )
            .pipe(catchErrorLogRet([]));
    }

    listDocuments(opts: BlListDocumentParams): Observable<BlDocument[]> {
        let params = new HttpParams();
        if (opts.focuses != null) {
            opts.focuses.forEach((e) => {
                params = params.append(
                    'focuses',
                    `${e.behaviourId}-${e.subBehaviourId ?? ''}`,
                );
            });
        }
        if (opts.includeEditorState != null) {
            params = params.set(
                'includeEditorState',
                String(opts.includeEditorState),
            );
        }
        if (opts.published != null) {
            params = params.set('published', String(opts.published));
        }
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/behaviour-library/documents`,
                { params },
            )
            .pipe(catchErrorLogRet([]));
    }
}
